import { api } from '../../http';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import { VerificationFunctions } from '../../types/interfaces/VerificationFunctions';

import Api from './api';
import IVerificationFunctionsApi from './interfaces/verificationFunctionsApi';

class VerificationFunctionsApi
  extends Api<VerificationFunctions>
  implements IVerificationFunctionsApi
{
  constructor(abortController: AbortController) {
    super('verificationFunction/', abortController);
  }

  async getForSelection() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'verificationFunction/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default VerificationFunctionsApi;
